module.exports = __webpack_public_path__ + "static/img/logo2.43172a06.png";